import qs from 'qs';

export default {
    namespaced: true,
    state: {
        payment_methods: {},
        shipping_methods: {},
        easypack_data: '',
        set_payment_methods_popup: {},

        loader: false,

        current_shipping: [],
        current_payment: "",

        simple_data: {},
        company_data: {},
        billing_data: {},
        shipping_data: {},
        acceptance: {},
        type_of_document: 'P',
        redirect_url: "",
        used_coupons: {}
    },
    mutations: {
        set_payments(state, payment) {
            state.payment_methods = payment;
        },
        set_payment_methods_popup(state, is_visible) {
            state.payment_methods = is_visible;
        },
        set_shipping(state, shipping) {
            state.shipping_methods = shipping;
        },
        set_current_shipping(state, shipping_id) {
            state.current_shipping = shipping_id
        },
        set_current_payment(state, payment_title) {
            console.log("current payment", payment_title)
            state.current_payment = payment_title
        },
        set_loader(state, status) {
            state.loader = status
        },
        set_redirect_url(state, url) {
            state.redirect_url = url
        },

        set_simple_data(state, data) {
            state.simple_data = data
        },
        set_company_data(state, data) {
            state.company_data = data
        },
        set_acceptance(state, data) {
            state.acceptance = data
        },
        set_billing_data(state, data) {
            state.billing_data = data
        },
        set_shipping_data(state, data) {
            console.log("SHIPPING DATA STATE", data)
            state.shipping_data = data

        },
        set_type_of_document(state, type) {
            state.type_of_document = type
        },
        set_list_of_used_coupons(state, coupons) {
            state.used_coupons = coupons
        },
        set_data_easypack(state, data) {
            //console.log("EasyPack DATA", data)
            state.easypack_data = data
        },
    },
    actions: {
        async setCustomerData({commit, state}, shipping_data) {
            let parameters = {
                action: 'setCustomerSimpleData',
                shipping_data: shipping_data,
                security: window.global.ajax_nonce,
            }
            // commit('set_loader', true);
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
            }).catch((e) => {
                console.log(e)
            })
        },
        async getCheckoutMethods({commit, state}, country_code) {
            console.log(window.global.ajax, 'ajax');
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'shipping_and_payment',
                    country: country_code,
                    headers: {
                        'content-type': 'application/json',
                    },
                }
            }).then((res) => {
                console.log("getCheckoutMethods function")
              //  console.log(res)
                if (res.data.payment) {
                    commit('set_payments', res.data.payment)
                    commit('set_shipping', res.data.shipping)
                    if (res.data.current_shipping) {
                        commit('set_current_shipping', res.data.current_shipping[0])
                    }
                }
            }).catch((e) => {
                console.log(e)
            })
        },
        async changeShippingMethods({commit, state}, shipping_id) {
            //console.log("alert");
			//alert('a-'+commit+', b-'+state+', c-'+shipping_id);
            // let parameters = {
            //     action: 'change_shipping_method',
            //     shipping_id: shipping_id,
            //     security: window.global.ajax_nonce,
            // }
            commit('set_loader', true);
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'change_shipping_method',
                    shipping_id: shipping_id,
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            }).then((res) => {
                commit('set_current_shipping', shipping_id);
                commit('set_loader', false);
            }).catch((e) => {
                console.log(e)
            })
        },
        async create_order({commit, state}) {
            let shipping_obj = {};
            for (let i = 0; i < state.shipping_methods.length; i++) {
                if (state.shipping_methods[i].id === state.current_shipping) {
                    shipping_obj = state.shipping_methods[i]
                }
            }
            let parameters = {
                action: 'create_order',
                simple_data: state.simple_data,
                company_data: state.company_data,
                billing_data: state.billing_data,
                shipping_data: state.shipping_data,
                easypack_data: state.easypack_data,
                current_shipping: shipping_obj,
                current_payment: state.current_payment,
                type_of_document: state.type_of_document,
                acceptance: state.acceptance,
                security: window.global.ajax_nonce,
            }
            console.log("state.shipping_data", state.shipping_data)
            console.log(parameters.shipping_data)

            await this.axios.post(window.global.ajax, qs.stringify(parameters)).then((res) => {
                console.log("AJAX RES", res)
                if (res.data.result === "success") {
                    commit('set_redirect_url', res.data.redirect)
                } else if (res.data.data.result === "error") {
                    commit('set_redirect_url', res.data.data.redirect)
                }
            })
        },
        async set_coupon({commit, state}, coupon) {

            let parameters = {
                action: 'use_coupons',
                coupon: coupon,
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters)).then((res) => {
                if (!res.data.success) {
                    this.commit('alerts/set_alert', {'message': res.data.data.message, 'success': res.data.success})
                }


            }).catch((e) => {
                console.log(e)
            })
        },
        async remove_coupon({commit, state}, coupon) {
            let parameters = {
                action: 'removeCoupon',
                coupon: coupon,
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters)).then((res) => {
                if (!res.data.success) {
                    this.commit('alerts/set_alert', {'message': res.data.data.message, 'success': res.data.success})
                }

            }).catch((e) => {
                console.log(e)
            })
        },
        async get_used_coupons({commit, state}) {
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'getUsedCoupons',
                }
            }).then((res) => {
                if (res.data.success) {
                    commit('set_list_of_used_coupons', res.data.data);
                }
            }).catch((e) => {
                console.log(e)
            })
        }
    },
    getters: {
        get_payment_methods: (state) => state.payment_methods,
        get_shipping_methods: (state) => state.shipping_methods,
        get_current_shipping_method: (state) => {
            for (let i = 0; i < state.shipping_methods.length; i++) {
                if (state.shipping_methods[i].id === state.current_shipping) {
                    return state.shipping_methods[i]
                }
            }
            return {
                "id": false
            };
        },
        get_current_payment_method: (state) => {
            return state.payment_methods[state.current_payment.payment_method]
        },
        loader: (state) => state.loader,
        get_redirect_url: (state) => state.redirect_url,

        get_simple_data: (state) => state.simple_data,
        get_company_data: (state) => state.company_data,
        get_billing_data: (state) => state.billing_data,
        get_shipping_data: (state) => state.shipping_data,
        getCountry: (state) => state.shipping_data.country ? state.shipping_data.country : state.billing_data.country,
        get_type_of_document: (state) => state.type_of_document,
        get_used_coupons_list: (state) => state.used_coupons,
        // get_payment_methods_popup: (state) => state.payment_methods_popup
    }
};
